import { DateRangePreset } from '../components/ui/DateRangePicker';

export const CAMPAIGN_DATE_PRESETS: DateRangePreset[] = [
  {
    label: 'Today',
    value: 'today',
    getDates: () => {
      const now = new Date();
      const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return { startDate: d, endDate: d };
    },
  },
  {
    label: 'Yesterday',
    value: 'yesterday',
    getDates: () => {
      const now = new Date();
      const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
      return { startDate: d, endDate: d };
    },
  },
  {
    label: 'Last 7 days',
    value: '7days',
    getDates: () => {
      const today = new Date();
      const endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      const startDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 6
      );
      return { startDate, endDate };
    },
  },
  {
    label: 'Last 30 days',
    value: '30days',
    getDates: () => {
      const today = new Date();
      const endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      const startDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 29
      );
      return { startDate, endDate };
    },
  },
  {
    label: 'This month',
    value: 'thisMonth',
    getDates: () => {
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      return { startDate, endDate };
    },
  },
  {
    label: 'Last month',
    value: 'lastMonth',
    getDates: () => {
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const endDate = new Date(now.getFullYear(), now.getMonth(), 0);
      return { startDate, endDate };
    },
  },
  {
    label: 'Last 12 weeks',
    value: '12weeks',
    getDates: () => {
      const today = new Date();
      const endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      const startDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - (12 * 7 - 1)
      );
      return { startDate, endDate };
    },
  },
  {
    label: 'Last 12 months',
    value: '12months',
    getDates: () => {
      const today = new Date();
      const endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );
      const startDate = new Date(
        today.getFullYear(),
        today.getMonth() - 12,
        today.getDate() + 1
      );
      return { startDate, endDate };
    },
  },
];
